<div class="unavailability-dialog">
  <h2 mat-dialog-title>
    {{ data.block ? "Edit blocked time" : "Block court time" }}
  </h2>
  <mat-dialog-content>
    <p class="mb-5 text-secondary">
      Players will see this period as unavailable. Internal notes remain
      private.
    </p>

    <form [formGroup]="form" class="grid gap-4 sm:grid-cols-2">
      <mat-form-field class="sm:col-span-2" subscriptSizing="dynamic">
        <mat-label>Court</mat-label>
        <mat-select formControlName="courtId" [disabled]="!!data.block">
          <mat-option *ngFor="let court of data.courts" [value]="court._id">
            {{ court.name }}
          </mat-option>
        </mat-select>
        <mat-error>Select a court.</mat-error>
      </mat-form-field>

      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Date</mat-label>
        <input matInput type="date" formControlName="date" />
        <mat-error>Select a date.</mat-error>
      </mat-form-field>

      <div class="flex min-h-14 items-center">
        <mat-checkbox color="primary" formControlName="allDay"
          >Complete day</mat-checkbox
        >
      </div>

      <ng-container *ngIf="!form.controls.allDay.value">
        <mat-form-field subscriptSizing="dynamic">
          <mat-label>Start time</mat-label>
          <input matInput type="time" formControlName="startTime" />
        </mat-form-field>
        <mat-form-field subscriptSizing="dynamic">
          <mat-label>End time</mat-label>
          <input matInput type="time" formControlName="endTime" />
        </mat-form-field>
      </ng-container>

      <mat-form-field class="sm:col-span-2" subscriptSizing="dynamic">
        <mat-label>Reason</mat-label>
        <mat-select formControlName="reasonCode">
          <mat-option *ngFor="let reason of reasons" [value]="reason.value">
            {{ reason.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="sm:col-span-2" subscriptSizing="dynamic">
        <mat-label>Internal notes (optional)</mat-label>
        <textarea
          matInput
          rows="3"
          maxlength="500"
          formControlName="notes"
        ></textarea>
        <mat-hint align="end"
          >{{ form.controls.notes.value?.length || 0 }}/500</mat-hint
        >
      </mat-form-field>
    </form>

    <div
      *ngIf="errorMessage"
      class="mt-4 rounded-lg bg-red-50 p-3 text-sm text-red-700"
      role="alert"
    >
      {{ errorMessage }}
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button
      *ngIf="data.block"
      mat-button
      color="warn"
      type="button"
      [disabled]="saving"
      (click)="cancelBlock()"
    >
      Cancel blocked time
    </button>
    <span class="flex-1"></span>
    <button mat-button type="button" [disabled]="saving" mat-dialog-close>
      Close
    </button>
    <button
      mat-flat-button
      color="primary"
      type="button"
      [disabled]="saving"
      (click)="save()"
    >
      {{ saving ? "Saving..." : "Save blocked time" }}
    </button>
  </mat-dialog-actions>
</div>
